module.exports = __webpack_public_path__ + "static/media/extension_v6.75dad407.svg";